import 'pages/products/discounts/discounts-list-modal-select.tag'
riot.tag2('product-edit-discounts', '  <div class="row">\n    <div class="col-md-12">\n      <catalog-static name="{opts.name}" add="{add}" cols="{cols}" rows="{value}" handlers="{handlers}" remove="true">\n        <yield to="toolbar">\n          <yield from="toolbar"></yield>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="title">{row.title}</datatable-cell>\n          <datatable-cell name="dateFrom">{row.dateFrom}</datatable-cell>\n          <datatable-cell name="dateTo">{row.dateTo}</datatable-cell>\n          <datatable-cell name="stepTime">{row.stepTime}ч.</datatable-cell>\n          <datatable-cell name="stepDiscount">{row.stepDiscount}</datatable-cell>\n          <datatable-cell name="summFrom"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.summFrom.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n          <datatable-cell name="summTo"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.summTo.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n          <datatable-cell name="countFrom">{row.countFrom}</datatable-cell>\n          <datatable-cell name="countTo">{row.countTo}</datatable-cell>\n          <datatable-cell name="week">{handlers.getListOfDays(row.week)}</datatable-cell>\n        </yield>\n      </catalog-static>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value || [];
    },
    set: function set(value) {
        self.value = value || [];
        self.update();
    }
});

self.cols = [{ name: 'id', value: '#' }, { name: 'title', value: 'Наименование' }, { name: 'dateFrom', value: 'Старт' }, { name: 'dateTo', value: 'Завершение' }, { name: 'stepTime', value: 'Шаг времени' }, { name: 'stepDiscount', value: 'Шаг скидки' }, { name: 'summFrom', value: 'От суммы' }, { name: 'summTo', value: 'До суммы' }, { name: 'countFrom', value: 'От кол-ва' }, { name: 'countTo', value: 'До кол-ва' }, { name: 'week', value: 'Дни недели' }];

self.add = function () {
    modals.create('discounts-list-modal-select', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            self.value = self.value || [];

            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            var ids = self.value.map(function (item) {
                return item.id;
            });

            items.forEach(function (item) {
                if (ids.indexOf(item.id) === -1) self.value.push(item);
            });

            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);

            self.update();
            this.modalHide();
        }
    });
};

self.handlers = {
    daysOfWeek: ['Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.', 'Вс.'],
    getListOfDays: function getListOfDays(days) {
        var _this = this;

        var items = days.split('');

        var result = items.map(function (item, i) {
            return item == 1 ? _this.daysOfWeek[i] : undefined;
        }).filter(function (item) {
            return item;
        }).join(',');

        return result;
    }
};

self.on('update', function () {
    if ('name' in opts && opts.name !== '') self.root.name = opts.name;

    if ('value' in opts) self.value = opts.value || [];
});
});


// WEBPACK FOOTER //
// ./pages/products/products/product-edit-discounts.tag